export default "__VITE_ASSET__b10204d1__"